import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner automotive-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">REAL ESTATE</h2>
						<div className="red-border"> </div>
						<p>digiPanda helps to bridge the gap between consumer and businesses with blueprint of efficiencies, focused on efficient operations.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
